// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2ylex","alert":"SettungsInbox_alert__3Uhta"};